export const FAQ_LOG_EVENT = {
  CLICK_FAQ_TOC: 'click_faq_toc',
  CLICK_FAQ_TAG: 'click_faq_tag',
  UPPER_FAQ_SHARE_CLICK: 'upper_faq_share_click',
  DETAIL_STICKY_BUTTON_CLICK: 'faq_detail_sticky_button_click',
  FAQ_RELATED_QNA_CLICK: 'faq_related_qna_click',
  FAQ_RELATED_BOARD_POST_CLICK: 'faq_related_board_post_click',
  CLICK_OUTER_LINK: 'click_outer_link',
} as const;
